import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { RxCross1 } from "react-icons/rx";
import { SuccessPopUp } from "../../../CommonComponents/SuccessPopUp";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import Select from "react-select";

function AddCoupon() {

    const navigate = useNavigate();
    const token = sessionStorage.getItem('tokenKey');

    // Array for storing image previews
    const BASE_URL = process.env.REACT_APP_PP_URL;
    const [isSubmitting, setIsSubmitting] = useState(false);

    const [couponCode, setCouponCode] = useState();
    const [description, setDescription] = useState();
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();
    const [discountType, setDiscountType] = useState({ value: 'Amount', label: "Amount", id: 1 });
    const [discountValue, setDiscountValue] = useState();
    const [minOrderValue, setMinOrderValue] = useState();
    const [maxDiscountAmount, setMaxDiscountAmount] = useState();
    const [maxUsePerUser, setMaxUsePerUser] = useState();
    const [referralCoupon, setReferralCoupon] = useState(false);
    const [shippingCoupon, setShippingCoupon] = useState(false);

    const content = {
        // title: title,
        couponCode: couponCode,
        description: description,
        startDate: startDate,
        endDate: endDate,
        ...(!shippingCoupon && { discountType: discountType?.value }),
        minOrderValue: minOrderValue,
        ...(!shippingCoupon && { discountValue: discountValue }),
        ...(discountType?.value === 'Percentage' && !shippingCoupon && { maxDiscountAmount: maxDiscountAmount }),
        // usedCount: usedCount,
        maxUsePerUser: maxUsePerUser,
        referralCoupon: referralCoupon,
        shippingCoupon: shippingCoupon
    };

    const members = async () => {
        if (isSubmitting) return;
        setIsSubmitting(true);
        try {
            const res = await fetch(`${BASE_URL}/admin/v1/couponCode/save`, {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(content)
            });
            const getRes = await res.json();
            if (getRes.errorCode === 0) {
                setAction('Coupon added successfully !');
                setShowPop(true);
                setNavv('ok');
                setMore('Add more');
            } else {
                setShowPop(true);
                setAction('something went wrong');
                setNavv('OK');
                setMore('cancel');
            }
        } catch (e) {
            console.log(e, 'error in member api')
            setShowPop(true);
            setAction('something went wrong');
            setNavv('OK');
            setMore('cancel');
        } finally {
            setIsSubmitting(false)
        }
    };

    const [showPop, setShowPop] = useState(false);
    const [action, setAction] = useState();
    const [navv, setNavv] = useState();
    const [more, setMore] = useState();

    const navToCat = useNavigate();
    const confirmPopUp = () => {
        if (navv === 'ok') {
            navToCat('/admin/gift');
            setShowPop(false);
        } else if (navv === 'OK') {
            setShowPop(false);
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            })
        }
    };

    const onCloseBtn = () => {
        if (more === 'Add more') {
            setShowPop(false);
            setCouponCode('');
            setDescription('');
            setStartDate('');
            setEndDate('');
            setDiscountType('');
            setDiscountValue('');
            setMinOrderValue('');
            setMaxDiscountAmount('');
            setMaxUsePerUser('');

            window.scrollTo({
                top: 0,
                behavior: 'smooth'  // Optional: Use 'auto' for instant scroll
            });
        } else if (more === 'cancel') {
            navToCat('/admin/gift');
        }
    };

    const handelStartDate = async (e) => {
        const getDate = e.target.value
        await setStartDate(getDate)
        if (endDate && new Date(endDate) < new Date(getDate)) {
            const trikh = new Date(getDate)
            trikh.setDate(trikh.getDate() + 1)
            setEndDate(trikh.toISOString().split('T')[0]);
        }
    };

    const stDate = new Date().toISOString().split('T')[0];

    const [showSuggestion, setShowSuggestion] = useState(false);
    const ref = useRef(null);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (!ref?.current?.contains(event.target)) {
                setShowSuggestion(false);
            };
        };
        document.addEventListener("mousedown", handleClickOutside);
    }, [ref]);

    // const [fillDis, setFillDis] = useState([...disType]);
    const disType = [{ label: "Amount", value: "Amount", id: 1 }, { label: "Percentage", value: "Percentage", id: 2 }];
    const [disValue, setDisValue] = useState('Rs');

    // const fillDisType = (e) => {
    //     const get = e
    //     // const fill = disType.filter((itm) => itm.toLowerCase().includes(get.toLowerCase()))
    //     // setFillDis(fill);
    // };
    useEffect(() => {
        if (discountType?.value === 'Amount') {
            setDisValue('Rs');
            setMaxDiscountAmount();
        } else if (discountType?.value === 'Percentage') {
            setDisValue('%');
        }
    }, [discountType]);
    // const addValue = (e) => {
    //     setDiscountType(e);
    //     setShowSuggestion(false);
    //     if (e === 'Amount') {
    //         setDisValue('Rs');
    //         setMaxDiscountAmount();
    //     } else if (e === 'Percentage') {
    //         setDisValue('%');
    //     }
    // };

    // Refs for scrolling
    const [errors, setErrors] = useState({});
    const couponCodeRef = useRef(null);
    const startDateRef = useRef(null);
    const endDateRef = useRef(null);
    const discountValueRef = useRef(null);
    const minOrderValueRef = useRef(null);
    const maxUsePerUserRef = useRef(null);

    const handleValidation = () => {
        let newErrors = {};
        // Check each field
        if (!couponCode?.trim()) newErrors.couponCode = "coupon Code Require";
        if (!startDate?.trim()) newErrors.startDate = "coupon Code Require";
        if (!endDate?.trim()) newErrors.endDate = "coupon Code Require";
        // if (!discountValue?.trim()) newErrors.discountValue = "coupon Code Require";
        if (!minOrderValue?.trim()) newErrors.minOrderValue = "coupon Code Require";
        if (!maxUsePerUser?.trim()) newErrors.maxUsePerUser = "coupon Code Require";
        setErrors(newErrors);

        if (Object.keys(newErrors).length > 0) {
            const firstErrorField = Object.keys(newErrors)[0];
            scrollToField(firstErrorField);
            return false;
        }
        return true;

    };

    const scrollToField = (field) => {
        switch (field) {
            case "couponCode":
                couponCodeRef.current?.scrollIntoView({ top: 0, behavior: "smooth" });
                break;
            case "startDate":
                startDateRef.current?.scrollIntoView({ top: 0, behavior: "smooth" });
                break;
            case "endDate":
                endDateRef.current?.scrollIntoView({ top: 0, behavior: "smooth" });
                break;
            case "discountValue":
                discountValueRef.current?.scrollIntoView({ top: 0, behavior: "smooth" });
                break;
            case "minOrderValue":
                minOrderValueRef.current?.scrollIntoView({ top: 0, behavior: "smooth" });
                break;
            case "maxUsePerUser":
                maxUsePerUserRef.current?.scrollIntoView({ top: 0, behavior: "smooth" });
                break;
            default:
                break;
        }
    };

    const handleSubmit = () => {
        handleValidation();
        if (handleValidation()) {
            members();
        }
    };

    return (
        <>
            <div className="add-item">
                <div className="row">
                    <div className="category-nav">
                        <div className="category-text">
                            <h4>Add Coupon</h4>
                        </div>
                        <div className="category-btn">
                            <button onClick={() => navigate(-1)}><RxCross1 /></button>
                        </div>
                    </div>
                    <hr />

                    <div className="main-container">
                        <div className="add-form">

                            {/* NAME*/}
                            <div className="d-flex w-100 m-b2 d-other">
                                <div className="add" ref={couponCodeRef}>
                                    <label style={errors.couponCode && { color: "red" }}>Coupon Code</label>
                                    <input
                                        type="text"
                                        value={couponCode}
                                        onChange={(e) => setCouponCode(e.target.value)}
                                    />
                                </div>

                                <div className="add" ref={minOrderValueRef}>
                                    <label style={errors.minOrderValue && { color: "red" }}>Min. Order Value</label>
                                    <input
                                        type="text"
                                        value={minOrderValue}
                                        onChange={(e) => { setMinOrderValue(e.target.value) }}
                                    />
                                </div>

                            </div>

                            {/* Mobile */}
                            <div className="d-flex w-100 m-b2 d-other">
                                <div className="add" ref={startDateRef}>
                                    <label style={errors.startDate && { color: "red" }}>StartDate</label>
                                    <input
                                        type="date"
                                        value={startDate}
                                        onChange={handelStartDate}
                                        className="date-input"
                                        min={stDate}
                                    />
                                </div>
                                <div className="add" ref={endDateRef}>
                                    <label style={errors.endDate && { color: "red" }}>End Date</label>
                                    <input
                                        type="date"
                                        value={endDate}
                                        onChange={(e) => setEndDate(e.target.value)}
                                        className="date-input"
                                        min={content?.startDate || stDate}
                                    />
                                </div>
                            </div>

                            <div className="d-flex w-100 m-b2 d-other">
                                <div className="add">
                                    <div className="d-flex check-box-avail">
                                        <input
                                            type="checkbox"
                                            name="referralCoupon"
                                            checked={shippingCoupon}
                                            onChange={() => setShippingCoupon(!shippingCoupon)}
                                            id="shippingCoupon"
                                        />
                                        <label htmlFor="shippingCoupon">Is Shipping Coupon ? </label>
                                    </div>
                                </div>
                                <div className="add">
                                    <div className="d-flex check-box-avail">
                                        <input
                                            type="checkbox"
                                            name="referralCoupon"
                                            checked={referralCoupon}
                                            onChange={() => setReferralCoupon(!referralCoupon)}
                                            id="check-box"
                                        />
                                        <label htmlFor="check-box">Is Referral Coupon ? </label>
                                    </div>
                                </div>
                            </div>

                            {!shippingCoupon && <div className="d-flex w-100 m-b2 d-other">
                                <div className="add parentid">
                                    <label>Discount Type</label>
                                    {/* <div className="btn-AddCat">
                                        <input
                                            type="text"
                                            value={discountType}
                                            onChange={(e) => { setDiscountType(e.target.value); fillDisType(e.target.value) }}
                                            onFocus={() => setShowSuggestion(true)}
                                        />
                                    </div>
                                    {
                                        showSuggestion && <div className="multiple-cat" ref={ref}>
                                            {
                                                fillDis.map((itm) => {
                                                    return (
                                                        <>
                                                            <div className="options">
                                                                <li onClick={() => { addValue(itm) }}>
                                                                    <p>{itm}</p>
                                                                </li>
                                                            </div>
                                                        </>
                                                    )
                                                })
                                            }
                                        </div>
                                    } */}
                                    <Select
                                        closeMenuOnSelect={true}
                                        name="colors"
                                        options={disType}
                                        value={discountType}
                                        defaultValue={disType?.[0]}
                                        onChange={(e) => { setDiscountType(e) }}
                                        className="basic-multi-select"
                                        classNamePrefix="select"
                                    />
                                </div>

                                {!shippingCoupon && <div className="add parentid" ref={discountValueRef}>
                                    <label style={errors.discountValue && { color: "red" }}>Discount Value</label>
                                    <div className="btn-AddCat">
                                        <input
                                            type="text"
                                            value={discountValue}
                                            onChange={(e) => setDiscountValue(e.target.value)}
                                        />
                                        <button>{disValue}</button>
                                    </div>
                                </div>}

                            </div>}

                            <div className="d-flex w-100 m-b2 d-other" ref={maxUsePerUserRef}>

                                <div className="add">
                                    <label style={errors.maxUsePerUser && { color: "red" }}>Max Used per person</label>
                                    <input
                                        type="text"
                                        value={maxUsePerUser}
                                        onChange={(e) => setMaxUsePerUser(e.target.value)}
                                    />
                                </div>

                                {
                                    !shippingCoupon && discountType?.value === 'Percentage' &&
                                    (
                                        <div className="add ">
                                            <label>Max. Discount Amount</label>
                                            <input
                                                type="text"
                                                value={maxDiscountAmount}
                                                onChange={(e) => { setMaxDiscountAmount(e.target.value) }}
                                            />
                                        </div>
                                    )
                                }
                            </div>

                            <div className="editer m-b2">
                                {/* Jodit Editor */}
                                <div className="add w-100">
                                    <label>Description</label>
                                    <CKEditor
                                        editor={ClassicEditor}
                                        config={{
                                            toolbar: {
                                                items: [
                                                    "heading",
                                                    "|",
                                                    "bold",
                                                    "italic",
                                                    "link",
                                                    "bulletedList",
                                                    "numberedList",
                                                    "|",
                                                    "indent",
                                                    "outdent",
                                                    "|",
                                                    "imageUpload",
                                                    "blockQuote",
                                                    "mediaEmbed",
                                                    "undo",
                                                    "redo",
                                                ],
                                            },
                                        }}
                                        data={description}
                                        onChange={(event, editor) => {
                                            const data = editor.getData();
                                            setDescription(data);
                                        }}
                                    />
                                </div>
                            </div>

                        </div>
                        <div className="btn submit-btn" style={{ justifyContent: "flex-start" }}>
                            <button onClick={handleSubmit} disabled={isSubmitting}>Submit</button>
                        </div>
                    </div>
                </div>
            </div>

            <SuccessPopUp
                isOpen={showPop}
                action={action}
                navv={navv}
                FutherMore={more}
                onClose={onCloseBtn}
                onConfirm={confirmPopUp}
            />
        </>
    )
}
export default AddCoupon;